// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__Q7vlc","fadein":"Popup_fadein__XBeJC"};